import React from "react";
import "./Projects.css";

function Projects()
{
	return (
		<section className="projectsSection" data-cursor="-inverse">
			<div className="projectsInner">
				
			</div>
		</section>
	);
}

export default Projects;
